import type { CmsApiDonateBlockData } from '#/modules/cms/api/types/blocks/CmsApiDonateBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsDonateBlockMapping: CmsBlockMapping<CmsApiDonateBlockData> = {
  invariant: [],
  width: CmsMappedBlockWidth.FULL,
  Component: dynamic(
    () =>
      import('./CmsDonateBlock').then((module) => ({
        default: module.CmsDonateBlock,
      })),
    { strategy: 'always' },
  ),
};
